import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft, Mountain, Check, Compass } from "lucide-react";
import { ROUTES } from "@/lib/routes";

const CheckoutCancel = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const feature = searchParams.get('feature');

  const adventurerFeatures = [
    "View community run details, photos & waypoints",
    "Trail segment difficulty feedback & sentiment",
    "Control run privacy (public/private)",
    "Edit and clean run tracks",
    "Enhanced dashboard insights",
    "Personalized trail recommendations"
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-muted/30 to-background flex items-center justify-center p-4">
      <Card className="w-full max-w-lg border-border/50 shadow-lg">
        <CardHeader className="text-center pb-4">
          <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-muted flex items-center justify-center">
            <Compass className="w-10 h-10 text-muted-foreground" />
          </div>
          <CardTitle className="text-2xl font-bold">No Problem!</CardTitle>
          <CardDescription className="text-base">
            Take your time. Your Scout account is ready when you are.
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-6">
          {feature && (
            <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 text-center">
              <p className="text-sm text-muted-foreground">
                You were trying to access a premium feature. Upgrade anytime to unlock it!
              </p>
            </div>
          )}

          <div className="space-y-3">
            <p className="text-sm font-medium text-center">
              What you're missing with Adventurer:
            </p>
            <ul className="space-y-2">
              {adventurerFeatures.map((feature, index) => (
                <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
                  <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" />
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          <div className="grid gap-3">
            <Button 
              variant="hero" 
              size="lg" 
              className="w-full"
              onClick={() => navigate(ROUTES.pricing)}
            >
              <Mountain className="w-4 h-4 mr-2" />
              View Plans Again
            </Button>
            
            <Button 
              variant="outline" 
              onClick={() => navigate(ROUTES.explore)}
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Continue Exploring as Scout
            </Button>
          </div>

          <p className="text-xs text-center text-muted-foreground">
            You can upgrade anytime from your settings or the pricing page.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default CheckoutCancel;
